/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { StatusNotificationCommand } from '../../models/status-notification-command';

export interface ApiOcppOperationStatusNotificationPost$Json$Params {
  chargerId?: string;
  allConnectors?: boolean;
      body?: StatusNotificationCommand
}

export function apiOcppOperationStatusNotificationPost$Json(http: HttpClient, rootUrl: string, params?: ApiOcppOperationStatusNotificationPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<StatusNotificationCommand>>> {
  const rb = new RequestBuilder(rootUrl, apiOcppOperationStatusNotificationPost$Json.PATH, 'post');
  if (params) {
    rb.query('chargerId', params.chargerId, {});
    rb.query('allConnectors', params.allConnectors, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<StatusNotificationCommand>>;
    })
  );
}

apiOcppOperationStatusNotificationPost$Json.PATH = '/api/OcppOperation/statusNotification';
